import { Components, Theme } from '@mui/material';

export const getMuiTabs = (theme: Theme): Components['MuiTabs'] => ({
  styleOverrides: {
    root: {
      backgroundColor: theme.palette.background.paper,
      borderBottom: `1px solid ${theme.palette.divider}`,
      minHeight: 32,
    },
    indicator: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      '& > span': {
        width: 'calc(100% - 32px)',
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
});
